import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateFavoriteExerciseSessionItem } from '../../../../api/diary-service';
import { useState } from 'react';

const useUpdateFavoriteSessionItem = () => {
    const queryClient = useQueryClient();
    const [isUpdatingAndSyncing, setIsUpdatingAndSyncing] = useState(false);

    const mutation = useMutation({
        mutationFn: updateFavoriteExerciseSessionItem
    });

    const updateAndSync = async (payload) => {
        setIsUpdatingAndSyncing(true);

        try {
            const res = await mutation.mutateAsync(payload);

            await Promise.all([
                queryClient.refetchQueries(['favorite-exercise-sessions']),
                queryClient.refetchQueries(['diary'])
            ]);

            return res?.item ?? res;
        } finally {
            setIsUpdatingAndSyncing(false);
        }
    };

    return {
        updateItem: updateAndSync,
        isUpdating: isUpdatingAndSyncing,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error
    };
};

export default useUpdateFavoriteSessionItem;
